import React from "react";
import { motion } from "framer-motion";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaClock,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaYoutube,
  FaArrowRight,
} from "react-icons/fa";
import "./Contact.css";
import finalBanner from "../assets/finalbanner.png";

const Contact = () => {
  return (
    <div className="ft-contact-master">

      {/* HERO */}
      <section
  className="hud-hero"
  style={{
    backgroundImage: `
      linear-gradient(
        to bottom,
        rgba(143, 182, 243, 0.65), /* light blue overlay (top) */
        rgba(214, 230, 250, 0.55), /* soft blue overlay (middle) */
        rgba(255, 255, 255, 0.75)  /* white overlay (bottom) */
      ),
      url(${finalBanner})
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="hero-content">
   <motion.h1
  className="hero-main-title"
  initial={{ opacity: 0, x: -60 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 0.9, ease: "easeOut" }}
>
  CONTACT US
</motion.h1>

  </div>
</section>

      {/* CONTACT */}
      <section className="ft-interface-section">
        <div className="contact-path-layer">
          <svg viewBox="0 0 600 400" preserveAspectRatio="none">
            <path d="M20 60 C 220 60, 320 200, 580 200" className="path-line" />
            <path
              d="M20 160 C 240 160, 340 280, 580 280"
              className="path-line delay"
            />
          </svg>
        </div>

        <div className="ft-container contact-grid">

          {/* LEFT */}
          <motion.div
            className="contact-info"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <div className="info-item">
              <FaEnvelope />
              <div>
                <span>EMAIL</span>
                <br/>
                <br/>
                <p>flowtechpumps@hotmail.com</p>
                  <p>info@flowtechpumps.com</p>
              </div>
              <br/>
            </div>

            <div className="info-item">
              <FaPhoneAlt />
              <div>
                <span>PHONE</span>
                <br/><br/>
                <p>080-297 61 428</p>
              </div>
              <br/>
            </div>

            <div className="info-item">
              <FaMapMarkerAlt />
              <div>
                <span>ADDRESS</span>
                <br/><br/>
                <p>
                  No. 186/10, Haragadde Village<br/>
Opp to Sri Chennakeshava Layout,<br/>
Haragadde, Jigani Anekal Main Road,<br/>
Bangalore-560105<br/>
                </p>
              </div>
              <br/>
            </div>

            <div className="info-item">
              <FaClock />
              <div>
                <span>WORKING HOURS</span>
                <br/>
              <br/>
                <p>Mon – Sat | 9 AM – 6 PM</p>
              </div>
            </div>

            <div className="social-row">
              <FaFacebookF />
              <FaTwitter />
              <FaLinkedinIn />
              <FaYoutube />
            </div>
          </motion.div>

          {/* RIGHT */}
          <motion.div
            className="contact-form-card"
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
          >
            <h3>Send Us a Message</h3>
            <p className="response-note">We reply within 24 hours</p>

            <form>
              <input type="text" placeholder="Your Name" />
              <input type="email" placeholder="Your Email" />
              <textarea rows="5" placeholder="Your Message"></textarea>
              <button type="submit">
                Send Message <FaArrowRight />
              </button>
            </form>
          </motion.div>

        </div>
      </section>

      {/* MAP */}
  <section className="map-section">
  <iframe
    title="Flowtech Pumps and Motors Location"
    src="https://www.google.com/maps?q=Flowtech%20Pumps%20and%20Motors%20Haragadde%20Jigani%20Bangalore&z=16&output=embed"
    loading="lazy"
    allowFullScreen
    className="map-frame"
  ></iframe>
</section>



    </div>
  );
};

export default Contact;
